import { Injectable } from '@angular/core';
import {ApiService} from './api.service';
import {MerchantContact} from '../../entities/merchant-contact.model';
import {Contact, ContactStatus} from '../../entities';

@Injectable()
export class MerchantService {

  private websiteContacts: MerchantContact[];

  constructor(private apiService: ApiService) {

  }

  async loadWebsiteContacts() {
    let data = await this.apiService.find(MerchantContact,
      'marketwebsite-contacts-of-next-week?withPresentationOnly=' + false).toPromise();
    data = data.filter(c => c.casFunction === 'Inhaber/Geschäftsführer');
    // Filter duplicates
    data = Array.from(new Set(data.map(a => a.id)))
      .map(id => {
        return data.find(a => a.id === id);
      });
    this.websiteContacts = data;
  }

  async getContacts() {
    if (!this.websiteContacts) {
      await this.loadWebsiteContacts();
    }
    return this.websiteContacts.filter(c => !c.merchantNoWebsiteParticipation);
  }

  async getContactsByAdvertisingPresentation(value = true) {
    if (!this.websiteContacts) {
      await this.loadWebsiteContacts();
    }
    if (value) {
      return this.websiteContacts.filter(c => c.merchantMarketwebsiteAdvertisingPresentation === true);
    }
    return this.websiteContacts.filter(c => !c.merchantMarketwebsiteAdvertisingPresentation);
  }

  async getContactsByTerms() {
    if (!this.websiteContacts) {
      await this.loadWebsiteContacts();
    }
    return this.websiteContacts.filter(c => !!c.lastTermsAcceptedAt);
  }

  async getResponsibleContacts() {
    if (!this.websiteContacts) {
      await this.loadWebsiteContacts();
    }
    return this.websiteContacts.filter(c => c.responsibleAccordingToTMG === '1');
  }

  /**
   * Convert class MerchantContact to Contact
   */
  merchantContactsToContact(merchantContacts: MerchantContact[]): Contact[] {
    const contacts: Contact[] = [];
    for (const item of merchantContacts) {
      const contact = new Contact(item);
      contact.casIsContact = true;
      contact.casIsCompany = false;
      contact.status = (item.status && item.status !== '') ? ContactStatus[item.status] : null;
      contact.responsibleAccordingToTMG = item.responsibleAccordingToTMG === '1';
      contact.merchantNumber = item.merchantNumber;
      contact.superordinateContact = new Contact();
      contact.superordinateContact.id = item.merchantId;
      contact.superordinateContact.merchantNumber = item.merchantNumber;
      contact.superordinateContact.company = item.merchantCompany;
      contact.superordinateContact.companyAdditional = item.merchantCompanyAdditional;
      contact.superordinateContact.noWebsiteParticipation = item.merchantNoWebsiteParticipation;
      contact.superordinateContact.marketwebsiteSelfPresentation = item.merchantMarketwebsiteSelfPresentation;
      contact.superordinateContact.advancedMarketwebsite = item.merchantAdvancedMarketwebsite;
      contact.superordinateContact.marketwebsiteAdvertisingPresentation = item.merchantMarketwebsiteAdvertisingPresentation;
      contacts.push(contact);
    }
    return contacts;
  }

  async searchMerchant(merchantNumber: string | number) {
    const contacts = await this.apiService.find<Contact>(Contact, 'contacts-by-merchant-number/' + merchantNumber).toPromise();
    let contact = null;
    if (contacts.length > 0) {
      const companyContact = contacts.filter((entry) => (entry.casIsCompany));
      if (companyContact != null && companyContact.length > 0) {
        contact = companyContact[0];
      }
    }
    return contact;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/merchant.service.ts